import { create, all } from "mathjs";
import { DATEDIF, DATEFORMAT, PERCENT } from "@utils/getFormulaValue.util";
const math = create(all);
math.import({ DATEDIF, PERCENT, DATEFORMAT });

export { math as mathlib };
